// Cache en memoria compartido por toda la sesion de la SPA.
//
// El problema que resuelve: cada pagina (Shop, Cupo asignado, el detalle de
// un vino) traia sus datos de Firestore en un useEffect propio, asi que
// cambiar de solapa y volver desmontaba el componente, perdia el estado y
// volvia a pedir todo de cero — spinner incluido, aunque los datos fueran los
// mismos de hace dos segundos.
//
// Vive fuera de React a proposito: sobrevive a que los componentes se
// desmonten, pero se limpia solo al recargar la pagina (F5), asi que nunca
// muestra datos de una sesion vieja ni de otro usuario.
//
// La politica es "stale-while-revalidate": si hay algo guardado se pinta al
// instante, y si ya paso el tiempo de frescura se vuelve a pedir callado por
// atras y se actualiza la pantalla cuando llega. Sirve porque el precio y la
// descripcion no cambian nunca en el medio de una visita, y el stock, que si
// puede moverse, lo valida el backend en el momento de la compra.

const TTL_FRESCO_MS = 60 * 1000;

const cache = new Map(); // clave -> { valor, guardadoEn }
const enVuelo = new Map(); // clave -> promesa, para no pedir dos veces lo mismo

// Devuelve lo guardado, o null si nunca se pidio. `fresco` dice si hace falta
// revalidar: false significa "usalo igual, pero pedilo de nuevo por atras".
export const leerCache = (clave, ttlFrescoMs = TTL_FRESCO_MS) => {
    const entrada = cache.get(clave);
    if (!entrada) return null;
    return {
        valor: entrada.valor,
        fresco: Date.now() - entrada.guardadoEn < ttlFrescoMs,
    };
};

export const guardarEnCache = (clave, valor) => {
    cache.set(clave, { valor, guardadoEn: Date.now() });
};

// Pide el dato y lo guarda. Si ya hay un pedido igual en curso se cuelga de
// ese en vez de disparar otro (pasa cuando dos componentes montan juntos).
export const obtenerConCache = (clave, cargar) => {
    const pendiente = enVuelo.get(clave);
    if (pendiente) return pendiente;
    const promesa = Promise.resolve()
        .then(cargar)
        .then((valor) => {
            guardarEnCache(clave, valor);
            return valor;
        })
        .finally(() => {
            enVuelo.delete(clave);
        });
    enVuelo.set(clave, promesa);
    return promesa;
};

// Borra todas las claves que empiezan con el prefijo. Se usa despues de una
// compra: el stock cambio, asi que lo guardado quedo viejo de verdad.
export const invalidarCache = (prefijo) => {
    for (const clave of Array.from(cache.keys())) {
        if (clave.startsWith(prefijo)) cache.delete(clave);
    }
};

export const CLAVE_VINOS = 'vinos:';
export const CLAVE_DETALLE = 'detalle-vino:';
